'use client';

import React__default, { useContext, useRef, useEffect, useMemo } from 'react';
import { LeftColumnContentWrapper } from './LeftColumnContent.css.js';
import { CascaderContext } from '../../../../context/reducer.js';
import DropdownItem from '../DropdownItem/index.js';
import ChildrenSearchFilter from '../ChildrenSearchFilter/index.js';
import { getParentCheckState, countSelectedChildrenFromParentId } from '../../../../helper.js';

var LeftColumnContent = function () {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state;
    var isMobile = props.isMobile, options = props.options, langCode = props.langCode;
    var _b = options.parent, parent = _b === void 0 ? [] : _b;
    var keyword = state.keyword, parentId = state.parentId, temporaryValue = state.temporaryValue, scrollPosition = state.scrollPosition;
    var leftColumnRef = useRef(null);
    useEffect(function () {
        var _a, _b;
        if (!leftColumnRef.current) {
            return;
        }
        if (!isMobile) {
            return;
        }
        if ((scrollPosition === null || scrollPosition === void 0 ? void 0 : scrollPosition.left) === 0) {
            return;
        }
        (_a = leftColumnRef === null || leftColumnRef === void 0 ? void 0 : leftColumnRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, (_b = scrollPosition === null || scrollPosition === void 0 ? void 0 : scrollPosition.left) !== null && _b !== void 0 ? _b : 0);
    }, [isMobile, scrollPosition]);
    return useMemo(function () { return (React__default.createElement(LeftColumnContentWrapper, { "data-cname": 'dropdown__body__leftColumn', isMobile: isMobile, ref: leftColumnRef }, keyword !== '' ? (React__default.createElement(ChildrenSearchFilter, null)) : (parent.map(function (item, index) {
        var _a;
        // detect have children or not
        var checkState = getParentCheckState(item.id, temporaryValue);
        var countChildren = countSelectedChildrenFromParentId(item.id, temporaryValue);
        return (React__default.createElement(DropdownItem, { key: "parent-item-".concat(index), checkState: checkState, label: item.name, id: item.id, parentId: item.id, isSelected: parentId === item.id, isSelectedValue: checkState !== 'none', isHaveChildren: true, jobCount: (_a = item.jobs) !== null && _a !== void 0 ? _a : 0, selectedCount: countChildren, leftColumnRef: leftColumnRef }));
    })))); }, [isMobile, keyword, parent, parentId, temporaryValue, langCode]);
};

export { LeftColumnContent as default };
//# sourceMappingURL=index.js.map
